<app-navigation (IsnavbarOpen)="toggleNavbar($event)"></app-navigation>
<div class="layout-content" [ngClass]="{ 'show': navbarOpen }">
    <router-outlet></router-outlet>
    <app-footer class="noselect"></app-footer>
</div>